<template>
  <a v-if="item.pathIt" :href="item.pathIt">
    <section class="top-banner" :class="'top-banner_' + item.theme">
      <picture>
        <source
          v-for="(img, ind) in sortedImages"
          :key="ind"
          :srcset="img.src"
          :media="img.media"
        />
        <img
          class="top-banner__bg"
          :src="sortedImages[sortedImages.length - 1].src"
        />
      </picture>
      <div class="container">
        <div class="top-banner__content _px-md-4 _py-sm-8 _py-md-12">
          <h1
            class="top-banner__title _fs-48 _lh-64 _lh-md-54 _lh-sm-38 _fs-sm-32 _fw-700 _mb-4"
            :style="{ color: item.color }"
            v-html="item.title"
          ></h1>
          <span
            v-if="item.descr"
            class="top-banner__descr _fs-30 _fs-sm-24 _lh-42 _lh-sm-32 _fw-400"
            :style="{ color: item.color }"
            v-html="item.descr"
          >
          </span>
          <slot name="button"></slot>
        </div>
      </div>
    </section>
  </a>
  <section v-else class="top-banner" :class="'top-banner_' + item.theme">
    <picture>
      <source
        v-for="(img, ind) in sortedImages"
        :key="ind"
        :srcset="img.src"
        :media="img.media"
      />
      <img
        class="top-banner__bg"
        :src="sortedImages[sortedImages.length - 1].src"
      />
    </picture>
    <div class="container">
      <div class="top-banner__content _px-md-4 _py-sm-8 _py-md-12">
        <h1
          class="top-banner__title _fs-48 _lh-64 _lh-md-54 _lh-sm-38 _fs-sm-32 _fw-700 _mb-4"
          :style="{ color: item.color }"
          v-html="item.title"
        ></h1>
        <span
          v-if="item.descr"
          class="top-banner__descr _fs-30 _fs-sm-24 _lh-42 _lh-sm-32 _fw-400"
          :style="{ color: item.color }"
          v-html="item.descr"
        >
        </span>
        <slot name="button"></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TopBanner",
  props: {
    item: Object,
  },
  computed: {
    sortedImages() {
      let numberPattern = /\d+/g;
      let arr = [...this.item.images];
      arr.sort(function (a, b) {
        let first = parseInt(a.media.match(numberPattern).join(""));
        let second = parseInt(b.media.match(numberPattern).join(""));
        if (first < second) {
          return -1;
        }
        if (first > second) {
          return 1;
        }
        return 0;
      });

      return arr;
    },
  },
  mounted() {
    console.log(this.item.pathIt)
  },
}
</script>

<style lang="scss" scoped>
.top-banner {
  position: relative;
  display: flex !important;
  align-items: center;
  background-color: color(green-light);
  width: 100%;
  height: 440px;

  @media screen and (max-width: 1220px) {
    background-color: color(light);
    border-bottom: 1px solid color(grey-second);
    flex-direction: column;
    height: auto;
  }

  picture {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    @media screen and (max-width: 1220px) {
      height: 440px;
      position: static;
    }

    @media screen and (max-width: 743px) {
      height: 180px;
    }
  }

  &__bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    z-index: 0;

    @media screen and (max-width: 1220px) {
      position: static;
    }

    @media screen and (max-width: 767px) {
      object-fit: contain;
      max-height: 200px;
      height: auto;
    }
  }

  &__content {
    position: relative;
    z-index: 1;
  }

  &__title,
  &__descr {
    @media screen and (max-width: 1220px) {
      color: #25282a !important;
    }
  }

  &_light {
    .top-banner {
      &__title,
      &__descr {
        color: color(white);
      }
    }
  }

  &_dark {
    .top-banner {
      &__title {
        color: color(dark);
      }
      &__descr {
        color: color(dark-grey);
      }
    }
  }
}
</style>

<style lang="scss">
.top-banner__descr br {
  @media screen and (max-width: 1220px) {
    display: none;
  }
}
</style>
